import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconHome: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 20 20" fill="none">
    <path
      d="M0 10.3152L9.293 0.315065C9.6835 -0.105022 10.3165 -0.105022 10.707 0.315065L20 10.3152H18V18.9239C18 19.5182 17.5523 20 17 20H12V12.4674H8V20H3C2.44772 20 2 19.5182 2 18.9239V10.3152H0Z"
      fill="currentColor"
    />
  </Svg>
)
